import makeStyles from '@mui/styles/makeStyles';

import { gradients } from '@/themesConfig/colors';
import { helveticaNeueBlack } from '@/themesConfig/helveticaNeueFonts';

export const useStyles = makeStyles(() => ({
  '@global': {
    '@font-face': helveticaNeueBlack,
  },

  marketingText: {
    fontFamily: 'helveticaNeueBlack, Helvetica, Arial, sans-serif',
    fontWeight: '900',
    lineHeight: '120%',
    textTransform: 'uppercase',
  },

  gradient: {
    background: gradients.marketing,
    backgroundClip: 'text',
    textFillColor: 'transparent',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
}));
